import Head from 'next/head'
import NextImage from 'next/image'

export const nextProviderValues = {
    components: {
        head: Head,
        image: NextImage,
    },
    // The list can be found in Cloudinary settings:
    // - https://console.cloudinary.com/settings/c-27ba5991496dab1985e57b4accc6fb/security
    cloudinaryAllowedDomains: [
        'doist.com',
        'doist.net',
        'todoist.com',
        'todoist.net',
        'twist.com',
        'doist.dev',
        'doist-emails.com',
        'dcff1xvirvpfp.cloudfront.net',
        'images.ctfassets.net',
        'blog.doist.com',
        'tdinspiration.wpengine.com',
        'local.todoist.com',
        'get.todoist.help',
        'lh6.googleusercontent.com',
        'pbs.twimg.com',
        'vercel.app',
        'us-central1.run.app',
    ],
}
